const PtPrizes = () => {
  return (
    <>
      <section>
        <p>
          Por favor, consulte as informações de 'Como Jogar' localizadas no
          website (
          <a
            href="https://br.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://br.nbafantasy.nba.com/help/rules
          </a>
          ) para detalhes completos sobre a acumulação de pontos.
        </p>
        <p>
          No total, serão 30 os vencedores do Concurso, de acordo com os
          seguintes critérios
        </p>
        <p>Ao Longo da Época</p>
        <p>
          Os prémios serão atribuídos aos cinco (5) Concorrentes melhor
          classificados, com a maior pontuação acumulada ao longo da época. Para
          evitar dúvidas, haverá um total de cinco (5) prémios a ganhar, NÃO
          cinco (5) prémios para cada país. Será atribuído um (1) Prémio por
          semana (vinte e cinco (25) no total) ao Concorrente com mais pontos
          numa determinada semana. Para evitar dúvidas, haverá um (1) prémio
          semanal total a ganhar, NÃO um (1) prémio semanal para cada país. Em
          caso de empate entre os Participantes para os prémios ao longo da
          época ou para um prémio semanal, será efectuado um desempate para
          determinar o vencedor. O desempate será feito pelo Participante que
          tiver iniciado sessão e criado a sua equipa primeiro (na data mais
          antiga) com base nos dados recolhidos pelo Patrocinador.
        </p>
        <h3>Grande Prémio - Primeiro (1.º) Lugar na Classificação Geral</h3>
        <p>
          Haverá um (1) Vencedor do Grande Prémio ("Vencedor do Grande Prémio")
          atribuído ao Participante com mais pontos acumulados durante a duração
          do Concurso.
        </p>
        <p>O "Grande Prémio" é composto por:</p>
        <ul>
          <li>
            <p>
              O transporte da residência dos Vencedores para Paris, França, será
              assegurado por meio de dois (2) bilhetes de avião de ida e volta
              em classe económica do aeroporto internacional mais próximo da
              residência dos Vencedores para um aeroporto em Paris, França, ou
              por meio de bilhetes de comboio de ida e volta da estação mais
              próxima da residência dos Vencedores para Paris, França (conforme
              determinado e indicado pelo Patrocinador ao seu exclusivo
              critério).
            </p>
            <ul>
              <li>
                <p>
                  A seleção específica de lugares fica ao exclusivo critério do
                  Patrocinador.
                </p>
              </li>
              <li>
                <p>
                  O método de transporte, as datas e os horários exatos serão
                  determinados pelo Patrocinador ao seu exclusivo critério
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Um (1) quarto de hotel para duas (2) pessoas em Paris durante três
              (3) noites num hotel de 3 a 4 estrelas
            </p>
            <ul>
              <li>
                <p>
                  Hotéis, quartos e datas a serem escolhidos pelo Patrocinador
                  ao seu exclusivo critério
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Dois (2) bilhetes para um (1) Jogo da NBA em Paris durante a época
              de 2027-28 da NBA (o "Jogo")
            </p>
            <ul>
              <li>
                <p>
                  A Data do Jogo Exata é da exclusiva responsabilidade do
                  Patrocinador
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Um troféu para o Primeiro Lugar, entregue pessoalmente ou por
              correio expresso no endereço do vencedor, a exclusivo critério do
              Patrocinador.
            </p>
          </li>
        </ul>
        <p>
          O valor total aproximado acumulado do Grande Prémio é de 2.500,00 €.
        </p>
        <p>
          O vencedor pode nomear um (1) amigo ou membro da família para
          participar com ele (o "Convidado").
        </p>
        <p>
          Os vencedores do Grande Prémio de qualquer época anterior não são
          elegíveis para reclamar o Grande Prémio. Nessas circunstâncias, o
          Grande Prémio será atribuído ao próximo Concorrente elegível, e o
          vencedor do Grande Prémio não elegível receberá, em vez disso, o
          prémio do Segundo (2.º) lugar.
        </p>
      </section>
      <section>
        <p>
          Quatro (4) Prémios Secundários Adicionais ao Longo da Época - Da
          segunda (2.ª) à quinta (5.ª) Classificação Geral Estes quatro (4)
          prémios secundários adicionais serão atribuídos aos Participantes com
          os segundo (2.º), terceiro (3.º), quarto (4.º) e quinto (5.º) maior
          número de pontos acumulados durante o período do Concurso (cada um
          "Vencedor do Prémio Secundário").
        </p>
        <ul>
          <li>
            <p>
              Prémio para o segundo (2.º) lugar: Cartão de oferta da Loja da NBA
              x 200,00 € em{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Prémio para o terceiro (3.º) lugar: Cartão de oferta da Loja da
              NBA x 200,00 € em{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Prémio para o quarto (4.º) lugar: Cartão de oferta da Loja da NBA
              x 200,00 € em{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Prémio para o quinto (5.º) lugar: Cartão de oferta da Loja da NBA
              x 200,00 € em{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://nbastore.eu
              </a>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h3>Semanalmente:</h3>
        <p>
          Serão atribuídos vinte e cinco (25) prémios adicionais ao Participante
          com mais pontos numa determinada semana (cada um deles um "Vencedor do
          Prémio Semanal"). Um (1) Prémio Semanal a ser atribuído por semana x
          25 semanas de duração total do concurso.
        </p>
        <p>
          O Prémio Semanal consistirá numa cópia digital do NBA 2K27 e num
          cartão de oferta da Loja NBA no valor de 100,00 € em{" "}
          <a
            href="https://nbastore.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://nbastore.eu
          </a>{" "}
          (a ser determinado pelo Patrocinador, a seu exclusivo critério). O
          valor total aproximado acumulado de um Prémio Semanal é de 150,00 €.
        </p>
        <p>
          Para serem elegíveis para os Prémios Semanais, os utilizadores devem
          ter entrado no jogo antes do início da época ou, no mínimo, 14 dias
          antes do início do período da semana de jogo relevante.
        </p>
        <p>
          Uma lista completa das semanas de jogo está disponível na secção{" "}
          <a
            href="https://br.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            como jogar
          </a>
          . As semanas de jogo estão sujeitas a alterações a exclusivo critério
          do Patrocinador.
        </p>
      </section>
      <section>
        <h3>Elegibilidade:</h3>
        <p>
          A Promoção está limitada a residentes da Áustria, Bélgica, República
          Checa, Dinamarca, Finlândia, França, Alemanha, Grécia, Hungria,
          Irlanda, Países Baixos, Noruega, Portugal, Sérvia, Espanha, Suíça e
          Reino Unido (em conjunto, o "Território"), que tenham dezoito (18)
          anos de idade ou mais à data da submissão da participação no concurso
          (cada um, um "Participante"). Para evitar dúvidas, os residentes fora
          das jurisdições acima mencionadas e/ou os Participantes que não tenham
          atingido a idade de dezoito (18) anos à data da submissão da
          participação no concurso, não são elegíveis para participar nesta
          Promoção. O Patrocinador, tal como definido abaixo, reserva-se o
          direito de confirmar a elegibilidade de qualquer Participante,
          incluindo a verificação da sua idade.
        </p>
      </section>
    </>
  );
};

export { PtPrizes };
